// 百度地图的url
// export const mapUrl = `${window.location.protocol}//api.map.baidu.com/api?v=3.0&ak=DQqcqMXiM9VWiRHCyla4ATMljvGFzh12&callback=onBMapCallback`;
export const mapUrl = `${window.location.protocol}//api.map.baidu.com/api?v=3.0&ak=jnBEZBjGTAEIcgDy5L38Fqf6Chd03smV&callback=onBMapCallback`;
// 点聚合相关js
export const textIconOverlayUrl = 'https://api.map.baidu.com/library/TextIconOverlay/1.2/src/TextIconOverlay_min.js';
// 点聚合相关js
export const markerClustererUrl = 'https://api.map.baidu.com/library/MarkerClusterer/1.2/src/MarkerClusterer_min.js';
// 画图工具相关
export const drawingManagerJsUrl = 'https://api.map.baidu.com/library/DrawingManager/1.4/src/DrawingManager_min.js';
export const drawingManagerCssUrl = 'https://api.map.baidu.com/library/DrawingManager/1.4/src/DrawingManager_min.css';